import React from "react";
import styled from "styled-components";
import { getMargin, MarginDescription } from "../CareConnectMobile-Theme";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  /** Adds margin on all sides of container */
  all?: MarginDescription;
  /** Adds margin on left side of container */
  left?: MarginDescription;
  /** Adds margin on top side of container */
  top?: MarginDescription;
  /** Adds margin on right side of container */
  right?: MarginDescription;
  /** Adds margin on bottom side of container */
  bottom?: MarginDescription;
  /** Set the container to use full width */
  fullWidth?: boolean;
  /** Set the container to user full height */
  fullHeight?: boolean;
  /** Transform the div */
  transform?: string;
}

/**
 * A simple container for layout that adds margins to the sides.
 */
const SpacerContainer = ({
  all,
  left,
  top,
  right,
  bottom,
  fullWidth,
  fullHeight,
  transform,
  children,
  ...props
}: Props) => {
  return <div {...props}>{children}</div>;
};

export default styled(SpacerContainer)`
  padding: ${(props) => props.all && getMargin(props.all)};
  padding-left: ${(props) => props.left && getMargin(props.left)};
  padding-top: ${(props) => props.top && getMargin(props.top)};
  padding-right: ${(props) => props.right && getMargin(props.right)};
  padding-bottom: ${(props) => props.bottom && getMargin(props.bottom)};
  height: ${(props) => props.fullHeight && `100%`};
  width: ${(props) => props.fullWidth && `100%`};
  transform: ${(props) => props.transform};
  box-sizing: ${(props) => "border-box"};
`;
